import { Grid, GridItem } from '../../../../components/index.js'

const ProductGridBox = ({
  BoxLeftGallery,
  BoxRightDetail,
  BoxBottomSummary,
}: {
  BoxLeftGallery: React.ReactNode
  BoxRightDetail: React.ReactNode
  BoxBottomSummary: React.ReactNode
}) => {
  return (
    <div id="ipc-product-card" className="laptop-md:pt-6 laptop-md:px-16 lg-desktop:px-[calc(50%-832px)]">
      <Grid className="laptop-md:gap-x-4 lg-desktop:gap-6 gap-8 laptop:gap-y-8 laptop-md:gap-y-8">
        <GridItem className="laptop:px-0 laptop-md:col-start-1 laptop-md:col-span-8 laptop-md:sticky laptop-md:top-[124px] col-span-12 h-fit">
          {BoxLeftGallery}
        </GridItem>
        <GridItem className="laptop-md:col-start-9 laptop-md:col-span-4 col-span-12">{BoxRightDetail}</GridItem>
      </Grid>
      {BoxBottomSummary}
    </div>
  )
}

export default ProductGridBox
